<!-- src/components/Inventario/Reportes/ConsumoMateriaPrima/components/CMPPanelResumen.vue -->
<template>
  <aside class="cmp-panel">
    <!-- Piezas fabricadas OK -->
    <div class="cmp-panel__card cmp-panel__card--piezas">
      <span class="cmp-panel__card-label">Piezas fabricadas OK</span>
      <div class="cmp-panel__comparacion">
        <div class="cmp-panel__col">
          <span class="cmp-panel__badge cmp-panel__badge--a">A</span>
          <span class="cmp-panel__valor">{{ formatearPiezas(totalPiezasA) }}</span>
        </div>
        <div class="cmp-panel__col">
          <span class="cmp-panel__badge cmp-panel__badge--b">B</span>
          <span class="cmp-panel__valor">{{ formatearPiezas(totalPiezasB) }}</span>
        </div>
      </div>
    </div>

    <!-- Tabla consumo TPU con más espacio -->
    <div class="cmp-panel__card cmp-panel__card--tabla">
      <span class="cmp-panel__card-label">Consumo de MP (kg)</span>
      <div class="cmp-panel__tabla-scroll">
        <table class="cmp-panel__tabla">
          <thead>
            <tr>
              <th>TPU</th>
              <th><span class="cmp-panel__badge cmp-panel__badge--a">A</span></th>
              <th><span class="cmp-panel__badge cmp-panel__badge--b">B</span></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="fila in filasTPU" :key="fila.tpu">
              <td>{{ fila.tpu }}</td>
              <td>{{ formatearKg(fila.kg_a) }}</td>
              <td>{{ formatearKg(fila.kg_b) }}</td>
            </tr>
            <tr v-if="!filasTPU.length">
              <td colspan="3" class="cmp-panel__vacio">Sin datos</td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="cmp-panel__total">
              <td>TOTAL</td>
              <td>{{ formatearKg(totalKgA) }}</td>
              <td>{{ formatearKg(totalKgB) }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </aside>
</template>

<script setup>
const props = defineProps({
  totalPiezasA: { type: Number, default: 0 },
  totalPiezasB: { type: Number, default: 0 },
  filasTPU: { type: Array, default: () => [] },
  totalKgA: { type: Number, default: 0 },
  totalKgB: { type: Number, default: 0 },
});

function formatearPiezas(valor) {
  if (valor === null || valor === undefined) return "—";
  return new Intl.NumberFormat("es-MX", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(valor);
}

function formatearKg(valor) {
  if (valor === null || valor === undefined) return "—";
  return new Intl.NumberFormat("es-MX", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(valor);
}
</script>

<style scoped>
/* Flex layout: Piezas OK en arriba, Tabla en toda la altura disponible */
.cmp-panel {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  min-height: 100%;
}

/* Card de piezas: altura fija pequeña */
.cmp-panel__card--piezas {
  flex-shrink: 0;
}

/* Card de tabla: se expande para llenar el espacio */
.cmp-panel__card--tabla {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0; /* Clave para que el scroll funcione */
}

/* Scroll interno de la tabla TPU — el scroll llena todo el espacio disponible */
.cmp-panel__tabla-scroll {
  flex: 1;
  overflow-y: auto;
  border-radius: 4px;
  min-height: 0;
}

/* El thead queda sticky dentro del scroll */
.cmp-panel__tabla thead th {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1;
}
</style>
